/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
import PropTypes from 'prop-types';

import BasicElement from '../../Elements/Basic';
import { addDays } from 'date-fns';
import { Tooltip } from 'src/components';

const Element = (props) => {
  const {
    time,
    style,
    title,
    start,
    end,
    classes,
    dataSet,
    tooltip,
    clickElement,
    isSubTrack,
  } = props;

  const handleClick = () => {
    clickElement(props);
  };
  const elementStyle = {
    ...time.toStyleLeftAndWidth(start, addDays(end, 1)),
    ...(clickElement ? { cursor: 'pointer' } : {}),
  };

  return (
    <div
      className=" absolute top-1.5"
      style={elementStyle}
      onClick={clickElement && handleClick && handleClick}
    >
      <BasicElement
        title={title}
        start={start}
        end={end}
        style={style}
        classes={classes}
        dataSet={dataSet}
        tooltip={tooltip}
        isSubTrack={isSubTrack}
        {...props}
      />
    </div>
  );
};

Element.propTypes = {
  time: PropTypes.shape({
    toStyleLeftAndWidth: PropTypes.func,
  }).isRequired,
  style: PropTypes.shape({}),
  classes: PropTypes.arrayOf(PropTypes.string.isRequired),
  dataSet: PropTypes.shape({}),
  title: PropTypes.string,
  start: PropTypes.instanceOf(Date).isRequired,
  end: PropTypes.instanceOf(Date).isRequired,
  tooltip: PropTypes.string,
  clickElement: PropTypes.func,
};

Element.defaultTypes = {
  clickElement: undefined,
};

export default Element;
